(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[277],{

/***/ 69308:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), 'LocationOn');
exports.Z = _default;

/***/ }),

/***/ 67070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft'));

/***/ }),

/***/ 56686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight'));

/***/ }),

/***/ 23370:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(()=>{return t={705:t=>{t.exports=function(t,e){const h=[];return 0===e.length?h.push({text:t,highlight:!1}):e[0][0]>0&&h.push({text:t.slice(0,e[0][0]),highlight:!1}),e.forEach(((i,o)=>{const s=i[0],r=i[1];h.push({text:t.slice(s,r),highlight:!0}),o===e.length-1?r<t.length&&h.push({text:t.slice(r,t.length),highlight:!1}):r<e[o+1][0]&&h.push({text:t.slice(r,e[o+1][0]),highlight:!1})})),h}}},e={},function h(i){var o=e[i];if(void 0!==o)return o.exports;var s=e[i]={exports:{}};return t[i](s,s.exports,h),s.exports}(705);var t,e}));

/***/ }),

/***/ 11752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(62156)


/***/ }),

/***/ 51686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ profile; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx
var Footer = __webpack_require__(91001);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tabs/Tabs.js + 5 modules
var Tabs = __webpack_require__(10724);
// EXTERNAL MODULE: ./node_modules/@mui/material/Snackbar/Snackbar.js + 4 modules
var Snackbar = __webpack_require__(14354);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(46901);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./src/components/index.ts + 105 modules
var components = __webpack_require__(67455);
// EXTERNAL MODULE: ./node_modules/react-phone-input-2/lib/bootstrap.css
var bootstrap = __webpack_require__(26497);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/icons/index.ts
var icons = __webpack_require__(46409);
// EXTERNAL MODULE: ./src/components/GoogleMapsAutoComplete/GoogleMapsAutoComplete.tsx
var GoogleMapsAutoComplete = __webpack_require__(44414);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/utils/google-location.tsx
var google_location = __webpack_require__(2892);
// EXTERNAL MODULE: ./src/components/Register/DateOfBirth/DateOfBirth.styles.ts
var DateOfBirth_styles = __webpack_require__(43696);
// EXTERNAL MODULE: ./src/utils/regex.tsx
var regex = __webpack_require__(37001);
// EXTERNAL MODULE: ./src/utils/dates.tsx
var dates = __webpack_require__(15443);
// EXTERNAL MODULE: ./src/services/AuthenticationService.tsx
var AuthenticationService = __webpack_require__(28148);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./src/pages/Profile/MainInfo/MainInfo.styles.ts


var ProfileInformationLabel = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.colors["neutral.500"],
    fontFamily: theme.fonts["default"],
    fontStyle: "normal",
    fontSize: theme.fontSizes.sm,
    margin: '0 0 .5rem 0'
  };
});
var ProfileInformation = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.colors["neutral.50"],
    fontFamily: theme.fonts["default"],
    fontStyle: "normal",
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim,
    fontSize: theme.fontSizes.lg
  };
});
var ActionLabel = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.colors["neutral.50"],
    fontFamily: theme.fonts["default"],
    fontStyle: "normal",
    fontSize: theme.fontSizes.md
  };
});
var InfoMessageContainer = (0,styled/* default */.ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    margin: '.5rem 0 .5rem 0'
  };
});
// EXTERNAL MODULE: ./src/components/Register/PhoneNumber/PhoneNumber.styles.ts
var PhoneNumber_styles = __webpack_require__(22039);
// EXTERNAL MODULE: ./src/components/Register/Accessibility/Accessibility.styles.ts
var Accessibility_styles = __webpack_require__(61975);
// EXTERNAL MODULE: ./src/components/Register/PhoneNumberVerification/PhoneNumberVerification.styles.ts
var PhoneNumberVerification_styles = __webpack_require__(81771);
// EXTERNAL MODULE: ./src/services/UserService.tsx
var UserService = __webpack_require__(92516);
// EXTERNAL MODULE: ./src/contexts/ModalContext.tsx
var ModalContext = __webpack_require__(19780);
// EXTERNAL MODULE: ./src/models/Accessibility.ts
var Accessibility = __webpack_require__(1967);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/Profile/MainInfo/MainInfo.tsx




























var MainInfo = function MainInfo(_ref) {
  var _profile$address, _profile$address2, _accessibilityOptions;

  var router = _ref.router,
      handleSubmit = _ref.handleSubmit,
      profile = _ref.profile,
      fetchProfile = _ref.fetchProfile;

  var _getConfig = config_default()(),
      publicRuntimeConfig = _getConfig.publicRuntimeConfig;

  var _useState = (0,react.useState)(""),
      currentlyEditing = _useState[0],
      setCurrentlyEditing = _useState[1];

  var _useState2 = (0,react.useState)(""),
      errorMsg = _useState2[0],
      setErrorMsg = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      resetPasswordLoading = _useState3[0],
      setResetPasswordLoading = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      resetPasswordSnackbarOpen = _useState4[0],
      setResetPasswordSnackbarOpen = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      resetPasswordError = _useState5[0],
      setResetPasswordError = _useState5[1];

  var _useState6 = (0,react.useState)(""),
      resetPasswordMessage = _useState6[0],
      setResetPasswordMessage = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      notificationSnackbarOpen = _useState7[0],
      setNotificationSnackbarOpen = _useState7[1];

  var _useState8 = (0,react.useState)(""),
      notificationSnackbarMessage = _useState8[0],
      setNotificationSnackbarMessage = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      notificationSnackbarError = _useState9[0],
      setNotificationSnackbarError = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      verificationCodeHasError = _useState10[0],
      setVerificationCodeHasError = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      userAlreadyHasAccessibility = _useState11[0],
      setUserAlreadyHasAccessibility = _useState11[1];

  var _useState12 = (0,react.useState)(true),
      verifyPhoneDisabled = _useState12[0],
      setVerifyPhoneDisabled = _useState12[1];

  var _useState13 = (0,react.useState)(true),
      verifyEmailDisabled = _useState13[0],
      setVerifyEmailDisabled = _useState13[1]; //input field values


  var _useState14 = (0,react.useState)(""),
      firstNameValue = _useState14[0],
      setFirstNameValue = _useState14[1];

  var _useState15 = (0,react.useState)(""),
      lastNameValue = _useState15[0],
      setLastNameValue = _useState15[1];

  var _useState16 = (0,react.useState)(""),
      emailValue = _useState16[0],
      setEmailValue = _useState16[1];

  var _useState17 = (0,react.useState)(false),
      emailValueValidating = _useState17[0],
      setEmailValueValidating = _useState17[1];

  var _useState18 = (0,react.useState)(""),
      phoneValue = _useState18[0],
      setPhoneValue = _useState18[1];

  var _useState19 = (0,react.useState)(false),
      phoneValueValidating = _useState19[0],
      setPhoneValueValidating = _useState19[1];

  var _useState20 = (0,react.useState)(""),
      smsValidationInputValue = _useState20[0],
      setSmsValidationInputValue = _useState20[1];

  var _useState21 = (0,react.useState)(),
      dayValue = _useState21[0],
      setDayValue = _useState21[1];

  var _useState22 = (0,react.useState)(),
      monthValue = _useState22[0],
      setMonthValue = _useState22[1];

  var _useState23 = (0,react.useState)(),
      yearValue = _useState23[0],
      setYearValue = _useState23[1];

  var _useState24 = (0,react.useState)(null),
      addressValue = _useState24[0],
      setAddressValue = _useState24[1];

  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      accessibilityVal = _React$useState2[0],
      setAccessibilityVal = _React$useState2[1];

  var _React$useState3 = react.useState(null),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      accessibilityIssue = _React$useState4[0],
      setAccessibilityIssue = _React$useState4[1];

  var _useModal = (0,ModalContext/* useModal */.dd)(),
      openModal = _useModal.openModal;

  (0,react.useEffect)(function () {
    fillLocalProfileState();
  }, [profile]);
  (0,react.useEffect)(function () {
    validate(currentlyEditing);
  }, [accessibilityVal, accessibilityIssue, firstNameValue, lastNameValue, yearValue, monthValue, dayValue, addressValue]);

  var fillLocalProfileState = function fillLocalProfileState() {
    var _profile$accessibilit, _profile$otherAccessi;

    setFirstNameValue(profile === null || profile === void 0 ? void 0 : profile.firstName);
    setLastNameValue(profile === null || profile === void 0 ? void 0 : profile.lastName);
    setEmailValue(profile === null || profile === void 0 ? void 0 : profile.email);
    setPhoneValue(profile === null || profile === void 0 ? void 0 : profile.phoneNumber);
    setDayValue(Number(dayjs_min_default()(profile === null || profile === void 0 ? void 0 : profile.dateOfBirth).format('DD')));
    setMonthValue(Number(dayjs_min_default()(profile === null || profile === void 0 ? void 0 : profile.dateOfBirth).format('MM')));
    setYearValue(Number(dayjs_min_default()(profile === null || profile === void 0 ? void 0 : profile.dateOfBirth).format('YYYY')));
    setAccessibilityVal((profile === null || profile === void 0 ? void 0 : profile.accessibility) === null && (profile === null || profile === void 0 ? void 0 : profile.otherAccessibility) === null ? null : (_profile$accessibilit = profile === null || profile === void 0 ? void 0 : profile.accessibility) !== null && _profile$accessibilit !== void 0 ? _profile$accessibilit : null);
    setAccessibilityIssue((_profile$otherAccessi = profile === null || profile === void 0 ? void 0 : profile.otherAccessibility) !== null && _profile$otherAccessi !== void 0 ? _profile$otherAccessi : null);
    setUserAlreadyHasAccessibility((profile === null || profile === void 0 ? void 0 : profile.accessibility) !== undefined && profile.accessibility !== null);
  };

  var CancelEditButton = function CancelEditButton() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
      gradientStyle: "gradient1",
      onClick: function onClick() {
        setCurrentlyEditing("");
        setErrorMsg("");
        fillLocalProfileState();
        setPhoneValueValidating(false);
        setEmailValueValidating(false);
      },
      size: "md",
      variant: "tertiary",
      sx: {
        padding: 0
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* Icon */.J, {
          icon: "X",
          size: "sm",
          sx: {
            marginRight: '.2rem'
          }
        }), " Cancel"]
      })
    });
  };

  var EditButton = function EditButton(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
      gradientStyle: "gradient1",
      onClick: function onClick() {
        setPhoneValueValidating(false);
        setEmailValueValidating(false);
        setCurrentlyEditing(props === null || props === void 0 ? void 0 : props.editType);
        setErrorMsg("");
      },
      size: "md",
      variant: "tertiary",
      sx: {
        padding: 0
      },
      disabled: props === null || props === void 0 ? void 0 : props.disabled,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* Icon */.J, {
          icon: "Pencil",
          size: "sm",
          sx: {
            marginRight: '.2rem'
          }
        }), " Edit"]
      })
    });
  };

  var UpdateButton = function UpdateButton(triggeredFrom) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
      sx: {
        margin: '.5rem 0 1.5rem auto'
      },
      gradientStyle: "gradient1",
      onClick: function onClick() {
        if (validate(currentlyEditing)) {
          if (userAlreadyHasAccessibility) {
            submit();
          } else {
            openModal(ModalContext/* Modals.AccessibilityRequirementsChange */.nK.AccessibilityRequirementsChange, function () {
              return submit();
            });
          }
        }
      },
      size: "sm",
      variant: "primary",
      children: "Update"
    });
  };

  var VerifyPhoneButton = function VerifyPhoneButton(triggeredFrom) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
      sx: {
        margin: '.5rem 0 1.5rem 0'
      },
      gradientStyle: "gradient1",
      onClick: function onClick() {
        setErrorMsg("");
        handlePhoneUpdate();
      },
      size: "sm",
      variant: "primary",
      disabled: verifyPhoneDisabled,
      children: "Verify Number"
    });
  };

  var VerifyEmailButton = function VerifyEmailButton(triggeredFrom) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
      sx: {
        margin: '.5rem 0 1.5rem 0'
      },
      gradientStyle: "gradient1",
      onClick: function onClick() {
        handleEmailUpdate();
        setErrorMsg("");
      },
      size: "sm",
      variant: "primary",
      disabled: verifyEmailDisabled,
      children: "Verify Email"
    });
  };

  var onAddressChange = function onAddressChange(value) {
    var registerAddress = {
      latitude: null,
      longitude: null,
      longLocation: null,
      shortLocation: null,
      detailsJson: null,
      country: "",
      unitOrApartmentNumber: null,
      street: "",
      suburb: null,
      state: null,
      postCode: ""
    };
    (0,google_location/* setGeocoderInfo */.j)(value, registerAddress);
    setAddressValue(registerAddress);
  };

  var triggerEmailValidation = function triggerEmailValidation() {
    if (emailValue) {
      if (!(0,regex/* emailValidation */.D6)(emailValue)) {
        setErrorMsg("The email you provided is incorrect!");
      } else {
        (0,UserService/* sendEmailVerificationCode */.dv)(emailValue).then(function (res) {
          if (res === true) {
            setEmailValueValidating(true);
            setNotificationSnackbarError(false);
            setNotificationSnackbarOpen(true);
            setNotificationSnackbarMessage("Nice! Your email with the code is on its way!");
            setErrorMsg("");
          } else {
            setNotificationSnackbarError(true);
            setNotificationSnackbarOpen(true);
            setNotificationSnackbarMessage(res !== null && res !== void 0 && res[0] ? res[0] : "Error! Please try again.");
            setErrorMsg(res !== null && res !== void 0 && res[0] ? res[0] : "Error! Please try again.");
          }
        });
      }
    } else {
      setErrorMsg("Please provide an email!");
    }
  };

  var triggerPhoneValidation = function triggerPhoneValidation() {
    if (phoneValue) {
      var phone = phoneValue.includes("+") ? phoneValue : "+" + phoneValue;
      (0,UserService/* sendPhoneNumberVerificationCodeWithAuth */.sF)(phone).then(function (res) {
        if (res === true) {
          setPhoneValueValidating(true);
          setNotificationSnackbarError(false);
          setNotificationSnackbarOpen(true);
          setNotificationSnackbarMessage("Nice! Your sms with the code is on its way!");
          setErrorMsg("");
        } else {
          setNotificationSnackbarError(true);
          setNotificationSnackbarOpen(true);
          setNotificationSnackbarMessage(res !== null && res !== void 0 && res[0] ? res[0] : "Error! Please try again.");
          setErrorMsg(res !== null && res !== void 0 && res[0] ? res[0] : "Error! Please try again.");
        }
      });
    } else {
      setErrorMsg("Please provide a phone number!");
    }
  };

  var handlePhoneUpdate = function handlePhoneUpdate() {
    if (phoneValue && smsValidationInputValue) {
      var phone = phoneValue.includes("+") ? phoneValue : "+" + phoneValue;
      (0,UserService/* confirmAndUpdatePhoneNumberViaCode */.Gd)(phone, smsValidationInputValue).then(function (res) {
        if (res === true) {
          setNotificationSnackbarError(false);
          setNotificationSnackbarOpen(true);
          setNotificationSnackbarMessage("Success! We saved your new phone number.");
          setPhoneValueValidating(false);
          setCurrentlyEditing("");
          fetchProfile();
        } else {
          setErrorMsg(res);
          setNotificationSnackbarError(true);
          setNotificationSnackbarOpen(true);
          setNotificationSnackbarMessage(res);
        }
      });
    } else {
      setErrorMsg("Please provide a phone number!");
      setPhoneValueValidating(false);
    }
  };

  var handleEmailUpdate = function handleEmailUpdate() {
    if (emailValue) {
      if (!(0,regex/* emailValidation */.D6)(emailValue)) {
        setErrorMsg("The email you provided is incorrect!");
        return;
      } else {
        if (smsValidationInputValue) {
          (0,UserService/* confirmAndUpdateEmailViaCode */.YU)(emailValue, smsValidationInputValue).then(function (res) {
            if (res === true) {
              setNotificationSnackbarError(false);
              setNotificationSnackbarOpen(true);
              setNotificationSnackbarMessage("Success! We saved your new email.");
              setEmailValueValidating(false);
              setCurrentlyEditing("");
              fetchProfile();
            } else {
              setErrorMsg(res);
              setNotificationSnackbarError(true);
              setNotificationSnackbarOpen(true);
              setNotificationSnackbarMessage(res);
            }
          });
        }
      }
    } else {
      setErrorMsg("Email is required!");
    }
  };

  var validate = function validate(triggeredFrom) {
    //validation
    if ((firstNameValue === null || firstNameValue === void 0 ? void 0 : firstNameValue.length) === 0 || (lastNameValue === null || lastNameValue === void 0 ? void 0 : lastNameValue.length) === 0) {
      setErrorMsg("First and last name are required!");
      return false;
    }

    if (!(0,dates/* validateBirthDate */.Dr)(yearValue, monthValue, dayValue)) {
      setErrorMsg("The birth date you provided is incorrect!");
      return false;
    }

    if (triggeredFrom === "address") {
      if (!(addressValue !== null && addressValue !== void 0 && addressValue.street)) {
        setErrorMsg("Street is mandatory!");
        return false;
      }
    }

    if (accessibilityVal === null && (accessibilityIssue === null || accessibilityIssue === void 0 ? void 0 : accessibilityIssue.trim()) === "") {
      setErrorMsg("You must select one Accessibility Requirement, even if the answer is ‘None’");
      return false;
    } else if (accessibilityVal === "Other" && (!accessibilityIssue || (accessibilityIssue === null || accessibilityIssue === void 0 ? void 0 : accessibilityIssue.trim()) === "")) {
      setErrorMsg("You must type in a custom Accessibility Requirement, if you selected ‘Other’");
      return false;
    }

    setErrorMsg("");
    return true;
  };

  var submit = function submit() {
    var birthDate = undefined;

    if (yearValue && monthValue && dayValue) {
      birthDate = new Date(yearValue, monthValue - 1, dayValue + 1);
    }

    var address = addressValue ? addressValue : profile === null || profile === void 0 ? void 0 : profile.address;
    var profileData = {
      firstName: firstNameValue,
      lastName: lastNameValue,
      email: emailValue,
      intentionalShortName: true,
      dateOfBirth: birthDate,
      phoneNumber: phoneValue,
      emailPreferences: profile === null || profile === void 0 ? void 0 : profile.emailPreferences,
      accessibility: accessibilityVal === "None" ? null : accessibilityVal,
      otherAccessibility: accessibilityIssue === "" ? null : accessibilityIssue === null || accessibilityIssue === void 0 ? void 0 : accessibilityIssue.trim(),
      address: {
        latitude: address.latitude,
        longitude: address.longitude,
        longLocation: address.longLocation,
        shortLocation: address.shortLocation,
        detailsJson: address.detailsJson,
        country: address.country,
        unitOrApartmentNumber: address.unitOrApartmentNumber,
        street: address.street,
        suburb: address.suburb,
        state: address.state,
        postCode: address.postCode,
        createdBy: ""
      }
    };
    handleSubmit(profileData);
    setErrorMsg("");
    setCurrentlyEditing("");
  };

  var handlePasswordReset = function handlePasswordReset() {
    setResetPasswordLoading(true);
    setResetPasswordSnackbarOpen(false);

    if (profile !== null && profile !== void 0 && profile.email) {
      (0,AuthenticationService/* forgotPasswordAdmin */.d5)({
        email: profile === null || profile === void 0 ? void 0 : profile.email
      }).then(function (res) {
        setResetPasswordLoading(false);

        if (res.status === 200) {
          setResetPasswordMessage("Your email has been sent.");
          setResetPasswordError(false);
          setResetPasswordSnackbarOpen(true);
        } else if (res.status === 400) {
          var _res$errors, _res$errors$message;

          setResetPasswordMessage((_res$errors = res.errors) === null || _res$errors === void 0 ? void 0 : (_res$errors$message = _res$errors.message) === null || _res$errors$message === void 0 ? void 0 : _res$errors$message[0]);
          setResetPasswordError(true);
          setResetPasswordSnackbarOpen(true);
        } else {
          setResetPasswordMessage("Oops! It looks like there's a hiccup. Please try again or contact support if the issue persists.");
          setResetPasswordError(true);
          setResetPasswordSnackbarOpen(true);
        }
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 2,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
          item: true,
          md: 12,
          marginBottom: 10,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformationLabel, {
              children: "Name"
            }), currentlyEditing !== "name" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tooltip */.u, {
              tooltipName: "profileFirstNameLock",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(EditButton, {
                editType: "name",
                disabled: true
              })
            }), currentlyEditing === "name" && /*#__PURE__*/(0,jsx_runtime.jsx)(CancelEditButton, {})]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [currentlyEditing === "name" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                gap: 2,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TextField */.nv, {
                  required: true,
                  value: firstNameValue,
                  onChange: function onChange(e) {
                    return setFirstNameValue(e.target.value);
                  },
                  placeholder: "first name",
                  size: "sm",
                  fullWidth: true,
                  "data-cy": "profile-tab-firstName"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TextField */.nv, {
                  required: true,
                  value: lastNameValue,
                  onChange: function onChange(e) {
                    return setLastNameValue(e.target.value);
                  },
                  placeholder: "last name",
                  size: "sm",
                  fullWidth: true,
                  "data-cy": "profile-tab-lastName"
                })]
              }), errorMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoMessageContainer, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
                  size: "sm",
                  variant: "error",
                  hasBackground: true,
                  message: errorMsg
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(UpdateButton, {
                triggeredFrom: "name"
              })]
            }), currentlyEditing !== "name" && /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
              direction: "row",
              gap: 1,
              marginBottom: 3,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformation, {
                "data-cy": "profile-tab-firstName",
                children: profile !== null && profile !== void 0 && profile.firstName ? profile.firstName : "-"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformation, {
                "data-cy": "profile-tab-lastName",
                children: profile !== null && profile !== void 0 && profile.lastName ? profile.lastName : "-"
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformationLabel, {
              children: "Email"
            }), currentlyEditing !== "email" && /*#__PURE__*/(0,jsx_runtime.jsx)(EditButton, {
              editType: "email",
              disabled: false
            }), currentlyEditing === "email" && /*#__PURE__*/(0,jsx_runtime.jsx)(CancelEditButton, {})]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [currentlyEditing === "email" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                gap: 2,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TextField */.nv, {
                  required: true,
                  value: emailValue,
                  onChange: function onChange(e) {
                    return setEmailValue(e.target.value);
                  },
                  placeholder: "email",
                  size: "sm",
                  fullWidth: true,
                  "data-cy": "profile-tab-email",
                  disabled: emailValueValidating
                })
              }), emailValueValidating ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PhoneNumberVerification_styles/* PhoneNumberVerificationContainer */.Vr, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TitleSubtitle */.V9, {
                    size: "sm",
                    subTitle: "We just emailed you a code, enter it below to verify email address"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneNumberVerification_styles/* FieldsContainer */.LA, {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* VerificationCodeInput */.aA, {
                      errorFromOutside: !!errorMsg,
                      inputLength: 6,
                      getConcatenatedValues: function getConcatenatedValues(value) {
                        setSmsValidationInputValue(value);
                        setVerifyEmailDisabled((value === null || value === void 0 ? void 0 : value.length) !== 6);
                      },
                      hasError: function hasError(value) {
                        setVerificationCodeHasError(value);
                      }
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PhoneNumberVerification_styles/* ResendCode */.df, {
                    children: ["Didn\u2019t get it? Check spam folder or ", /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneNumberVerification_styles/* StyledBlueSpan */.gj, {
                      onClick: function onClick() {
                        return triggerEmailValidation();
                      },
                      children: "Resend code"
                    })]
                  })]
                }), errorMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoMessageContainer, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
                    size: "sm",
                    variant: "error",
                    hasBackground: true,
                    message: errorMsg
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(VerifyEmailButton, {
                  triggeredFrom: "email"
                })]
              }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [errorMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoMessageContainer, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
                    size: "sm",
                    variant: "error",
                    hasBackground: true,
                    message: errorMsg
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
                  sx: {
                    margin: '.5rem 0 1.5rem auto'
                  },
                  gradientStyle: "gradient1",
                  onClick: function onClick() {
                    return triggerEmailValidation();
                  },
                  size: "sm",
                  variant: "primary",
                  children: "Update"
                })]
              })]
            }), currentlyEditing !== "email" && /*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
              direction: "row",
              gap: 1,
              marginBottom: 3,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformation, {
                "data-cy": "profile-tab-email",
                children: profile !== null && profile !== void 0 && profile.email ? profile.email : "-"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformationLabel, {
              children: "Phone"
            }), currentlyEditing !== "phone" && /*#__PURE__*/(0,jsx_runtime.jsx)(EditButton, {
              editType: "phone",
              disabled: false
            }), currentlyEditing === "phone" && /*#__PURE__*/(0,jsx_runtime.jsx)(CancelEditButton, {})]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [currentlyEditing === "phone" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                gap: 2,
                paddingTop: 1,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneNumber_styles/* CustomPhoneInput */.s, {
                  value: phoneValue,
                  onChange: function onChange(value) {
                    return setPhoneValue(value);
                  },
                  country: "au",
                  inputProps: {
                    name: 'phone',
                    required: true,
                    autoFocus: true
                  },
                  disabled: phoneValueValidating
                })
              }), phoneValueValidating ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PhoneNumberVerification_styles/* PhoneNumberVerificationContainer */.Vr, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TitleSubtitle */.V9, {
                    size: "sm",
                    subTitle: "Enter the code we just sent you via text below"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneNumberVerification_styles/* FieldsContainer */.LA, {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* VerificationCodeInput */.aA, {
                      errorFromOutside: !!errorMsg,
                      inputLength: 6,
                      getConcatenatedValues: function getConcatenatedValues(value) {
                        setSmsValidationInputValue(value);
                        setVerifyPhoneDisabled((value === null || value === void 0 ? void 0 : value.length) !== 6);
                      },
                      hasError: function hasError(value) {
                        setVerificationCodeHasError(value);
                      }
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PhoneNumberVerification_styles/* ResendCode */.df, {
                    children: ["Didn\u2019t get it? ", /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneNumberVerification_styles/* StyledBlueSpan */.gj, {
                      onClick: function onClick() {
                        return triggerPhoneValidation();
                      },
                      children: "Resend code"
                    })]
                  })]
                }), errorMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoMessageContainer, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
                    size: "sm",
                    variant: "error",
                    hasBackground: true,
                    message: errorMsg
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(VerifyPhoneButton, {
                  triggeredFrom: "phone"
                })]
              }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [errorMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoMessageContainer, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
                    size: "sm",
                    variant: "error",
                    hasBackground: true,
                    message: errorMsg
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
                  sx: {
                    margin: '.5rem 0 1.5rem auto'
                  },
                  gradientStyle: "gradient1",
                  onClick: function onClick() {
                    return triggerPhoneValidation();
                  },
                  size: "sm",
                  variant: "primary",
                  children: "Update"
                })]
              })]
            }), currentlyEditing !== "phone" && /*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
              direction: "row",
              gap: 1,
              marginBottom: 3,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformation, {
                children: profile !== null && profile !== void 0 && profile.phoneNumber ? profile.phoneNumber : "-"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformationLabel, {
              children: "Date of Birth(DD/MM/YY)"
            }), currentlyEditing !== "birth" && /*#__PURE__*/(0,jsx_runtime.jsx)(EditButton, {
              editType: "birth",
              disabled: false
            }), currentlyEditing === "birth" && /*#__PURE__*/(0,jsx_runtime.jsx)(CancelEditButton, {})]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [currentlyEditing === "birth" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                gap: 2,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DateOfBirth_styles/* DateTextField */.d0, {
                  "data-cy": "register-date-of-birth-day",
                  placeholder: "DD",
                  value: dayValue,
                  onChange: function onChange(value) {
                    return setDayValue(value);
                  },
                  InputProps: {
                    inputProps: {
                      min: 0
                    }
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateOfBirth_styles/* DateTextField */.d0, {
                  "data-cy": "register-date-of-birth-month",
                  placeholder: "MM",
                  value: monthValue,
                  onChange: function onChange(value) {
                    return setMonthValue(value);
                  },
                  InputProps: {
                    inputProps: {
                      min: 0
                    }
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateOfBirth_styles/* DateTextField */.d0, {
                  "data-cy": "register-date-of-birth-year",
                  placeholder: "YYYY",
                  value: yearValue,
                  onChange: function onChange(value) {
                    return setYearValue(value);
                  },
                  InputProps: {
                    inputProps: {
                      min: 0
                    }
                  }
                })]
              }), errorMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoMessageContainer, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
                  size: "sm",
                  variant: "error",
                  hasBackground: true,
                  message: errorMsg
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(UpdateButton, {
                triggeredFrom: "birth"
              })]
            }), currentlyEditing !== "birth" && /*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
              direction: "row",
              gap: 1,
              marginBottom: 3,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformation, {
                children: profile !== null && profile !== void 0 && profile.dateOfBirth ? dayjs_min_default()(profile.dateOfBirth).format("DD / MM / YY") : "-"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformationLabel, {
              children: "Address"
            }), currentlyEditing !== "address" && /*#__PURE__*/(0,jsx_runtime.jsx)(EditButton, {
              editType: "address",
              disabled: false
            }), currentlyEditing === "address" && /*#__PURE__*/(0,jsx_runtime.jsx)(CancelEditButton, {})]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [currentlyEditing === "address" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                gap: 2,
                paddingTop: 1,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleMapsAutoComplete/* default */.Z, {
                  id: "google-maps-autocomplete",
                  apiKey: publicRuntimeConfig.googleMapsApiKey,
                  value: addressValue,
                  onChange: onAddressChange,
                  newUIUXStyle: true,
                  "data-cy": "modal-shootinglocation-location"
                })
              }), errorMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoMessageContainer, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
                  size: "sm",
                  variant: "error",
                  hasBackground: true,
                  message: errorMsg
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(UpdateButton, {
                triggeredFrom: "address"
              })]
            }), currentlyEditing !== "address" && /*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
              direction: "row",
              gap: 1,
              marginBottom: 3,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformation, {
                children: profile !== null && profile !== void 0 && (_profile$address = profile.address) !== null && _profile$address !== void 0 && _profile$address.longLocation ? profile === null || profile === void 0 ? void 0 : (_profile$address2 = profile.address) === null || _profile$address2 === void 0 ? void 0 : _profile$address2.longLocation : "-"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformationLabel, {
              children: "Accessibility Requirements"
            }), currentlyEditing !== "accessibility" && /*#__PURE__*/(0,jsx_runtime.jsx)(EditButton, {
              editType: "accessibility",
              disabled: false
            }), currentlyEditing === "accessibility" && /*#__PURE__*/(0,jsx_runtime.jsx)(CancelEditButton, {})]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [currentlyEditing === "accessibility" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "column",
                justifyContent: "space-between",
                gap: 2,
                paddingTop: 1,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Accessibility_styles/* TagContainer */.x, {
                  children: (0,toConsumableArray/* default */.Z)(Accessibility/* accessibilityOptionsMapWithNone */.qI).map(function (_ref2) {
                    var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
                        key = _ref3[0],
                        value = _ref3[1];

                    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tag */.Vp, {
                      label: value,
                      isActive: accessibilityVal === key,
                      isControlled: true,
                      onClick: function onClick() {
                        setAccessibilityVal(key);
                        setAccessibilityIssue("");
                      },
                      onDelete: function onDelete() {
                        setAccessibilityVal(null);
                      }
                    }, "option-".concat(key));
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TextField */.nv, {
                  fullWidth: true,
                  label: "Other",
                  placeholder: "Please Specify",
                  value: accessibilityIssue !== null && accessibilityIssue !== void 0 ? accessibilityIssue : "",
                  onChange: function onChange(event) {
                    setAccessibilityIssue(event.target.value);
                    setAccessibilityVal("Other");
                  }
                })]
              }), errorMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoMessageContainer, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
                  size: "sm",
                  variant: "error",
                  hasBackground: true,
                  message: errorMsg
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(UpdateButton, {
                triggeredFrom: "accessibility"
              })]
            }), currentlyEditing !== "accessibility" && /*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
              direction: "row",
              gap: 1,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileInformation, {
                children: accessibilityIssue && accessibilityIssue != "" ? accessibilityIssue : (_accessibilityOptions = Accessibility/* accessibilityOptionsMapWithNone.get */.qI.get(accessibilityVal !== null && accessibilityVal !== void 0 ? accessibilityVal : "None")) !== null && _accessibilityOptions !== void 0 ? _accessibilityOptions : "-"
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          md: 12,
          marginBottom: 10,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ActionLabel, {
              children: "Change Password?"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
              gradientStyle: "gradient1",
              onClick: function onClick() {
                return handlePasswordReset();
              },
              size: "md",
              variant: "tertiary",
              sx: {
                padding: 0
              },
              loading: resetPasswordLoading,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* Icon */.J, {
                  icon: "Mail",
                  size: "sm",
                  sx: {
                    marginRight: '.2rem'
                  }
                }), " Send Reset Email"]
              })
            })]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
      open: resetPasswordSnackbarOpen,
      autoHideDuration: 6000,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      onClose: function onClose() {
        return setResetPasswordSnackbarOpen(false);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
        onClose: function onClose() {
          return setResetPasswordSnackbarOpen(false);
        },
        severity: resetPasswordError ? 'error' : 'success',
        sx: {
          width: '100%'
        },
        children: resetPasswordMessage
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
      open: notificationSnackbarOpen,
      autoHideDuration: 6000,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      onClose: function onClose() {
        return setNotificationSnackbarOpen(false);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
        onClose: function onClose() {
          return setNotificationSnackbarOpen(false);
        },
        severity: notificationSnackbarError ? 'error' : 'success',
        sx: {
          width: '100%'
        },
        children: notificationSnackbarMessage
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Modal */.u_, {})]
  });
};

/* harmony default export */ var MainInfo_MainInfo = ((0,router.withRouter)(MainInfo));
// EXTERNAL MODULE: ./src/services/BookingInterestService.tsx + 1 modules
var BookingInterestService = __webpack_require__(5668);
// EXTERNAL MODULE: ./node_modules/material-ui-confirm/dist/material-ui-confirm.esm.js
var material_ui_confirm_esm = __webpack_require__(65536);
// EXTERNAL MODULE: ./src/services/TicketService.tsx
var TicketService = __webpack_require__(5394);
;// CONCATENATED MODULE: ./src/pages/Profile/BookingInterestManagement/BookingInterestManagement.styles.ts

var BookingInterestsContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    gap: theme.space._500
  };
});
var CTAContainer = (0,styled/* default */.ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._400,
    alignSelf: "strech",
    marginTop: theme.space._400
  };
});
// EXTERNAL MODULE: ./src/services/AttendanceService.tsx
var AttendanceService = __webpack_require__(2090);
;// CONCATENATED MODULE: ./src/pages/Profile/BookingInterestManagement/BookingInterestManagement.tsx















var BookingInterestManagement = function BookingInterestManagement(_ref) {
  var bookingInterests = _ref.bookingInterests,
      fetchBookingInterests = _ref.fetchBookingInterests,
      router = _ref.router;

  var _useState = (0,react.useState)('accept'),
      actionName = _useState[0],
      setActionName = _useState[1];

  var _useState2 = (0,react.useState)(false),
      snackbarErrorOpen = _useState2[0],
      setSnackbarErrorOpen = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      snackbarSuccessOpen = _useState3[0],
      setSnackbarSuccessOpen = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      snackbarUpdateSuccessOpen = _useState4[0],
      setSnackbarUpdateSuccessOpen = _useState4[1];

  var _useState5 = (0,react.useState)(undefined),
      snackbarMessage = _useState5[0],
      setSnackbarMessage = _useState5[1];

  var _useState6 = (0,react.useState)(),
      acceptTicketBookingInterest = _useState6[0],
      setAcceptTicketBookingInterest = _useState6[1];

  var _useState7 = (0,react.useState)(null),
      pendingTicketGenerationId = _useState7[0],
      setPendingTicketGenerationId = _useState7[1];

  var _useModal = (0,ModalContext/* useModal */.dd)(),
      openModal = _useModal.openModal,
      setCurrentTexts = _useModal.setCurrentTexts,
      modalBookingData = _useModal.modalBookingData;

  var ticketPollInterval = 1000;
  var maxTicketPollingAttempts = 60;
  var pollTimerRef = (0,react.useRef)(null);
  var fetchBookingInterestsRef = (0,react.useRef)(fetchBookingInterests);
  var bookingInterestsRef = (0,react.useRef)(bookingInterests);
  var modalBookingDataRef = (0,react.useRef)(modalBookingData);
  var ticketPollStateRef = (0,react.useRef)({
    ticketId: null,
    ticketWasCleared: false,
    attempts: 0
  });
  var confirm = (0,material_ui_confirm_esm/* useConfirm */.N)();
  (0,react.useEffect)(function () {
    fetchBookingInterestsRef.current = fetchBookingInterests;
    bookingInterestsRef.current = bookingInterests;
    modalBookingDataRef.current = modalBookingData;
  }, [fetchBookingInterests, bookingInterests, modalBookingData]);
  var stopTicketPolling = (0,react.useCallback)(function () {
    if (pollTimerRef.current) {
      clearInterval(pollTimerRef.current);
      pollTimerRef.current = null;
    }

    setPendingTicketGenerationId(null);
    ticketPollStateRef.current = {
      ticketId: null,
      ticketWasCleared: false,
      attempts: 0
    };
  }, []);
  (0,react.useEffect)(function () {
    if (!pendingTicketGenerationId) {
      stopTicketPolling();
      return;
    }

    if (pollTimerRef.current) {
      clearInterval(pollTimerRef.current);
      pollTimerRef.current = null;
    }

    pollTimerRef.current = setInterval( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _bookingInterest$tick, _bookingInterest$tick2;

      var pollState, bookingInterest, currentTicketId, isTicketReady, ticketIdChanged, ticketRegenerated;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pollState = ticketPollStateRef.current;
              bookingInterest = bookingInterestsRef.current.find(function (item) {
                return item.id === pendingTicketGenerationId;
              });
              currentTicketId = (_bookingInterest$tick = bookingInterest === null || bookingInterest === void 0 ? void 0 : (_bookingInterest$tick2 = bookingInterest.ticket) === null || _bookingInterest$tick2 === void 0 ? void 0 : _bookingInterest$tick2.id) !== null && _bookingInterest$tick !== void 0 ? _bookingInterest$tick : null;
              isTicketReady = Boolean(currentTicketId);
              ticketIdChanged = pollState.ticketId != null && currentTicketId != null && currentTicketId !== pollState.ticketId;
              ticketRegenerated = isTicketReady && (ticketIdChanged || pollState.ticketWasCleared || pollState.ticketId == null);

              if (bookingInterest && bookingInterest.ticket == null) {
                pollState.ticketWasCleared = true;
              }

              if (!(ticketRegenerated || pollState.attempts >= maxTicketPollingAttempts)) {
                _context.next = 10;
                break;
              }

              stopTicketPolling();
              return _context.abrupt("return");

            case 10:
              pollState.attempts += 1;
              _context.next = 13;
              return fetchBookingInterestsRef.current();

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), ticketPollInterval);
    return function () {
      if (pollTimerRef.current) {
        clearInterval(pollTimerRef.current);
        pollTimerRef.current = null;
      }
    };
  }, [pendingTicketGenerationId, ticketPollInterval, maxTicketPollingAttempts, stopTicketPolling]);

  var handleClose = function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarErrorOpen(false);
    setSnackbarSuccessOpen(false);
    setSnackbarUpdateSuccessOpen(false);
  };

  var handleVerifyUserAndTicketAccessibilityMatch = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(bookingInterest) {
      var res;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setAcceptTicketBookingInterest(bookingInterest);
              _context2.next = 3;
              return (0,TicketService/* verifyUserAndTicketAccessibilityMatch */.rs)(bookingInterest.id);

            case 3:
              res = _context2.sent;

              if (!res.error) {
                _context2.next = 9;
                break;
              }

              setCurrentTexts({
                mainBody: res.error
              });
              openModal(ModalContext/* Modals.AcceptTicket */.nK.AcceptTicket, onAcceptTicketModalClick);
              _context2.next = 12;
              break;

            case 9:
              _context2.next = 11;
              return handleAcceptTicket(bookingInterest);

            case 11:
              setAcceptTicketBookingInterest(undefined);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleVerifyUserAndTicketAccessibilityMatch(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleAcceptTicket = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(bookingInterest) {
      var res;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setActionName("accept");
              _context3.next = 3;
              return (0,TicketService/* acceptTicket */.p3)(bookingInterest.id);

            case 3:
              res = _context3.sent;

              if (!res) {
                _context3.next = 11;
                break;
              }

              _context3.next = 7;
              return fetchBookingInterests();

            case 7:
              setSnackbarUpdateSuccessOpen(false);
              setSnackbarSuccessOpen(true);
              _context3.next = 12;
              break;

            case 11:
              setSnackbarErrorOpen(true);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleAcceptTicket(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleDeclineTicket = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(bookingInterest) {
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setActionName("decline");
              confirm({
                description: "Are you going to decline the ticket? Caution: This action is permanent and cannot be reversed."
              }).then( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
                var res;
                return regenerator_default().wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return (0,TicketService/* declineTicket */.XN)(bookingInterest.id);

                      case 2:
                        res = _context4.sent;

                        if (!res) {
                          _context4.next = 10;
                          break;
                        }

                        _context4.next = 6;
                        return fetchBookingInterests();

                      case 6:
                        setSnackbarUpdateSuccessOpen(false);
                        setSnackbarSuccessOpen(true);
                        _context4.next = 11;
                        break;

                      case 10:
                        setSnackbarErrorOpen(true);

                      case 11:
                        return _context4.abrupt("return", new Promise(function (resolve, reject) {
                          resolve();
                        }));

                      case 12:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              })));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleDeclineTicket(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleDeclineAttendance = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(bookingInterest) {
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              setActionName("check-in decline");
              confirm({
                description: "Are you going to decline the ticket check-in? Caution: This action is permanent and cannot be reversed."
              }).then( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
                var res;
                return regenerator_default().wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return (0,AttendanceService/* declineAttendanceByIdOrToken */.B)(bookingInterest.id);

                      case 2:
                        res = _context6.sent;

                        if (!res) {
                          _context6.next = 10;
                          break;
                        }

                        _context6.next = 6;
                        return fetchBookingInterests();

                      case 6:
                        setSnackbarUpdateSuccessOpen(false);
                        setSnackbarSuccessOpen(true);
                        _context6.next = 11;
                        break;

                      case 10:
                        setSnackbarErrorOpen(true);

                      case 11:
                        return _context6.abrupt("return", new Promise(function (resolve, reject) {
                          resolve();
                        }));

                      case 12:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              })));

            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function handleDeclineAttendance(_x4) {
      return _ref7.apply(this, arguments);
    };
  }();

  var handleDownloadTicket = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(userEmail, ticketId) {
      var res;
      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              setActionName("download");
              _context8.next = 3;
              return (0,TicketService/* downloadTicket */.qB)(userEmail, ticketId);

            case 3:
              res = _context8.sent;

              if (res) {
                setSnackbarUpdateSuccessOpen(false);
                setSnackbarSuccessOpen(true);
              } else {
                setSnackbarErrorOpen(true);
              }

              return _context8.abrupt("return", new Promise(function (resolve, reject) {
                resolve();
              }));

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function handleDownloadTicket(_x5, _x6) {
      return _ref9.apply(this, arguments);
    };
  }();

  var onAcceptTicketModalClick = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9() {
      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (acceptTicketBookingInterest) {
                _context9.next = 2;
                break;
              }

              return _context9.abrupt("return");

            case 2:
              _context9.next = 4;
              return handleAcceptTicket(acceptTicketBookingInterest);

            case 4:
              setAcceptTicketBookingInterest(undefined);

            case 5:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function onAcceptTicketModalClick() {
      return _ref10.apply(this, arguments);
    };
  }();

  var onModalCTAClick = /*#__PURE__*/function () {
    var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10(successful, message) {
      var _modalBookingDataRef$, _modalBookingDataRef$2, bookingInterestId, _bookingInterestsRef$, _bookingInterestsRef$2, _bookingInterestsRef$3, currentTicketId;

      return regenerator_default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if (successful) {
                setSnackbarSuccessOpen(false);
                setSnackbarMessage(message);
                setSnackbarUpdateSuccessOpen(true);
                bookingInterestId = (_modalBookingDataRef$ = modalBookingDataRef.current) === null || _modalBookingDataRef$ === void 0 ? void 0 : (_modalBookingDataRef$2 = _modalBookingDataRef$.bookingInterest) === null || _modalBookingDataRef$2 === void 0 ? void 0 : _modalBookingDataRef$2.id;

                if (bookingInterestId) {
                  currentTicketId = (_bookingInterestsRef$ = (_bookingInterestsRef$2 = bookingInterestsRef.current.find(function (item) {
                    return item.id === bookingInterestId;
                  })) === null || _bookingInterestsRef$2 === void 0 ? void 0 : (_bookingInterestsRef$3 = _bookingInterestsRef$2.ticket) === null || _bookingInterestsRef$3 === void 0 ? void 0 : _bookingInterestsRef$3.id) !== null && _bookingInterestsRef$ !== void 0 ? _bookingInterestsRef$ : null;
                  setPendingTicketGenerationId(bookingInterestId);
                  ticketPollStateRef.current = {
                    ticketId: currentTicketId,
                    ticketWasCleared: false,
                    attempts: 0
                  };
                }
              }

              _context10.next = 3;
              return fetchBookingInterests();

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function onModalCTAClick(_x7, _x8) {
      return _ref11.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [(bookingInterests === null || bookingInterests === void 0 ? void 0 : bookingInterests.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(BookingInterestsContainer, {
      children: bookingInterests.map(function (bookingInterest, index) {
        var _bookingInterest$allo, _bookingInterest$allo2;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* BookingCard */.Lv, {
          bookingInterest: bookingInterest,
          isTicketGenerating: pendingTicketGenerationId === bookingInterest.id,
          colour: ((_bookingInterest$allo = bookingInterest.allocationSession) === null || _bookingInterest$allo === void 0 ? void 0 : (_bookingInterest$allo2 = _bookingInterest$allo.allocation) === null || _bookingInterest$allo2 === void 0 ? void 0 : _bookingInterest$allo2.type) == "Priority" ? components/* priorityColorArray */._f[index % components/* priorityColorArray.length */._f.length] : components/* colorArray */.SJ[index % components/* colorArray.length */.SJ.length],
          handleAcceptTicket: handleVerifyUserAndTicketAccessibilityMatch //temporary - Pending on Tiket Offer pages
          ,
          handleDeclineTicket: handleDeclineTicket //temporary
          ,
          handleDownloadTicket: handleDownloadTicket //temporary
          ,
          handleDeclineAttendance: handleDeclineAttendance,
          onModalAction: onModalCTAClick
        }, "booking-interest-".concat(bookingInterest.id));
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CTAContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "body1",
          children: "You don't have any tickets yet."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
          "data-cy": "login-button",
          onClick: function onClick() {
            return router.push("/audience");
          },
          children: "Apply To Shows Here"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Modal */.u_, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
      open: snackbarErrorOpen,
      autoHideDuration: 10000,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Alert/* default */.Z, {
        onClose: handleClose,
        severity: "error",
        sx: {
          width: "100%",
          fontSize: "16px"
        },
        children: ["Ticket ", actionName, " failed!"]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
      open: snackbarSuccessOpen,
      autoHideDuration: 6000,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Alert/* default */.Z, {
        onClose: handleClose,
        severity: "success",
        sx: {
          width: "100%",
          fontSize: "16px",
          marginTop: "70px"
        },
        children: ["Ticket ", actionName, " successful!"]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
      open: snackbarUpdateSuccessOpen,
      autoHideDuration: 6000,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
        onClose: handleClose,
        severity: "success",
        sx: {
          width: "100%",
          fontSize: "16px",
          marginTop: "70px"
        },
        children: snackbarMessage ? snackbarMessage : "Tickets updated successfully!"
      })
    })]
  });
};

/* harmony default export */ var BookingInterestManagement_BookingInterestManagement = ((0,router.withRouter)(BookingInterestManagement));
// EXTERNAL MODULE: ./node_modules/@mui/material/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(40044);
;// CONCATENATED MODULE: ./src/pages/Profile/Profile.styles.ts


var PanelContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    alignSelf: "stretch",
    width: "100%",
    flexDirection: "column"
  };
});
var TabPanelBox = (0,styled/* default */.ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    alignSelf: "stretch",
    width: "100%",
    flexDirection: "column",
    gap: theme.space._500
  };
});
var TabsContainer = (0,styled/* default */.ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    flexDirection: "column",
    gap: theme.space._500,
    minWidth: "14rem",
    "& .MuiTabs-indicator": {
      background: "none"
    },
    "@media (max-width: 768px)": {
      display: "none"
    }
  };
});
var StyledTab = (0,styled/* default */.ZP)(Tab/* default */.Z)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    display: "flex",
    padding: "".concat(theme.space._200, " 0"),
    justifyContent: "flex-start",
    minHeight: "fit-content",
    gap: theme.space._300,
    alignItems: "center",
    textTransform: "unset",
    fontFamily: theme.fonts["default"],
    fontSize: theme.fontSizes.md,
    lineHeight: theme.lineHeights.base,
    fontWeight: theme.fontWeights.regular,
    "&.MuiTab-root": {
      color: theme.colors["neutral.50"],
      "& .MuiTab-iconWrapper": {
        color: theme.colors["pink.500"]
      },
      "&.Mui-selected": {
        color: theme.colors["lime.500"],
        "& .MuiTab-iconWrapper": {
          color: theme.colors["lime.500"]
        }
      }
    }
  };
});
var ProfilePageContainer = (0,styled/* default */.ZP)("div")(function (_ref5) {
  var theme = _ref5.theme;
  return {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: theme.space._800,
    maxWidth: "57rem",
    paddingTop: "9rem",
    margin: "auto",
    backgroundColor: theme.colors["neutral.950"],
    color: theme.colors["neutral.50"],
    "@media (max-width: 900px)": {
      paddingLeft: theme.space._400,
      paddingRight: theme.space._400,
      paddingTop: "7rem"
    }
  };
});
var HeaderContainer = (0,styled/* default */.ZP)("div")(function (_ref6) {
  var theme = _ref6.theme;
  return {
    display: "flex",
    alignItems: "center",
    gap: theme.space._300,
    marginBottom: theme.space._200,
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts["default"]
  };
});
var InfoContainer = (0,styled/* default */.ZP)("span")(function (_ref7) {
  var theme = _ref7.theme;
  return {
    display: "flex",
    flexDirection: "column",
    gap: theme.space._100,
    ".AccountMenu_username": {
      fontSize: theme.fontSizes.md,
      fontWeight: theme.fontWeights.bold
    }
  };
});
var TitleTypography = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref8) {
  var theme = _ref8.theme;
  return {
    fontFamily: theme.fonts["default"],
    fontSize: theme.fontSizes["3xl"],
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim,
    color: theme.colors.white
  };
});
var SubTitleTypography = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref9) {
  var theme = _ref9.theme;
  return {
    fontFamily: theme.fonts["default"],
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.slim,
    color: theme.colors["neutral.500"]
  };
});
// EXTERNAL MODULE: ./src/utils/auth.tsx
var auth = __webpack_require__(22877);
// EXTERNAL MODULE: ./src/contexts/AuthContext.tsx
var AuthContext = __webpack_require__(82030);
;// CONCATENATED MODULE: ./src/pages/Profile/Profile.tsx




var _excluded = ["children", "value", "index"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















function TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      other = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TabPanelBox, _objectSpread(_objectSpread({
    role: "tabpanel",
    hidden: value !== index,
    id: "vertical-tabpanel-".concat(index),
    "aria-labelledby": "vertical-tab-".concat(index)
  }, other), {}, {
    children: value === index && /*#__PURE__*/(0,jsx_runtime.jsx)(TabPanelBox, {
      children: children
    })
  }));
}

function a11yProps(index) {
  return {
    id: "vertical-tab-".concat(index),
    "aria-controls": "vertical-tabpanel-".concat(index)
  };
}

;
var tabNameToIndex = {
  'tickets': 0,
  'account': 1,
  'profile': 2 //TODO: Account tab styling + profile Tab

};
var indexToTabName = {
  0: 'tickets',
  1: 'account',
  2: 'profile'
};

var Profile = function Profile(_ref) {
  var router = _ref.router;

  var _useState = (0,react.useState)(),
      profile = _useState[0],
      setProfile = _useState[1];

  var _useState2 = (0,react.useState)([]),
      bookingInterests = _useState2[0],
      setBookingInterests = _useState2[1];

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      snackbarErrorOpen = _React$useState2[0],
      setSnackbarErrorOpen = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      snackbarSuccessOpen = _React$useState4[0],
      setSnackbarSuccessOpen = _React$useState4[1];

  var query = router.query;

  var _useAuthContext = (0,AuthContext/* useAuthContext */.E)(),
      setUser = _useAuthContext.setUser,
      user = _useAuthContext.user;

  var tabParam = query.tab;
  var tab = typeof tabParam === 'string' ? tabParam : '';
  var initialTab = tabNameToIndex[tab.toLowerCase()] || 0;

  var _React$useState5 = react.useState(initialTab),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      tabIndex = _React$useState6[0],
      setTabIndex = _React$useState6[1];

  var handleClose = function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarErrorOpen(false);
    setSnackbarSuccessOpen(false);
  };

  var handleMainInfo = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
      var res;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,UserService/* updateUser */.Nq)(_objectSpread(_objectSpread({}, values), {}, {
                id: profile === null || profile === void 0 ? void 0 : profile.id,
                addressId: profile === null || profile === void 0 ? void 0 : profile.addressId
              }));

            case 2:
              res = _context.sent;

              if (res) {
                fetchProfile();
                setSnackbarSuccessOpen(true);
              } else {
                setSnackbarErrorOpen(true);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleMainInfo(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onTabChange = function onTabChange(event, newValue) {
    setTabIndex(newValue);
  };

  (0,react.useEffect)(function () {
    var tabName = indexToTabName[tabIndex];
    router.replace("/profile".concat(tabName ? "?tab=".concat(tabName) : ''), undefined, {
      shallow: true,
      scroll: false
    });
  }, [tabIndex]);
  (0,react.useEffect)(function () {
    var tabParam = router.query.tab;
    var tab = typeof tabParam === 'string' ? tabParam : '';
    var newTabIndex = tabNameToIndex[tab.toLowerCase()] || 0;

    if (newTabIndex !== tabIndex) {
      setTabIndex(newTabIndex);
    }
  }, [router.query]);

  var fetchProfile = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var res, _res$email, _res$dateOfBirth, _res$accessibility, _res$otherAccessibili;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0,UserService/* getProfile */.Ai)();

            case 2:
              res = _context2.sent;

              if (res && user) {
                setProfile(res);
                setUser(_objectSpread(_objectSpread({}, user), {}, {
                  email: (_res$email = res.email) !== null && _res$email !== void 0 ? _res$email : user.email,
                  dateOfBirth: (_res$dateOfBirth = res.dateOfBirth) !== null && _res$dateOfBirth !== void 0 ? _res$dateOfBirth : user.dateOfBirth,
                  accessibility: (_res$accessibility = res.accessibility) !== null && _res$accessibility !== void 0 ? _res$accessibility : user.accessibility,
                  otherAccessibility: (_res$otherAccessibili = res.otherAccessibility) !== null && _res$otherAccessibili !== void 0 ? _res$otherAccessibili : user.otherAccessibility
                }));
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchProfile() {
      return _ref3.apply(this, arguments);
    };
  }();

  var fetchBookingInterests = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var _yield$readUserBookin, data;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0,BookingInterestService/* readUserBookingInterests */.Cv)();

            case 2:
              _yield$readUserBookin = _context3.sent;
              data = _yield$readUserBookin.data;
              if (data) setBookingInterests(data);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fetchBookingInterests() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleLogout = function handleLogout(event) {
    event.stopPropagation;
    (0,auth/* logoutUser */.TX)();
  };

  (0,react.useEffect)(function () {
    fetchProfile();
    fetchBookingInterests();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ProfilePageContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TabsContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Avatar */.qE, {
          initials: (0,components/* getInitials */.Qm)(profile === null || profile === void 0 ? void 0 : profile.firstName, profile === null || profile === void 0 ? void 0 : profile.lastName)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(InfoContainer, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "AccountMenu_username",
            children: [profile === null || profile === void 0 ? void 0 : profile.firstName, " ", profile === null || profile === void 0 ? void 0 : profile.lastName]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
        value: tabIndex,
        onChange: onTabChange,
        "aria-label": "profile tabs",
        orientation: "vertical",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTab, _objectSpread(_objectSpread({
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* Icon */.J, {
            icon: "Ticket"
          })
        }, a11yProps(0)), {}, {
          iconPosition: "start",
          label: "Applications & Tickets",
          "data-cy": "ticketManagement-tab"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTab, _objectSpread(_objectSpread({
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* Icon */.J, {
            icon: "User"
          })
        }, a11yProps(1)), {}, {
          iconPosition: "start",
          label: "Account Details",
          "data-cy": "accountDetails-tab"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTab, {
          onClick: function onClick(event) {
            return handleLogout(event);
          },
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* Icon */.J, {
            icon: "Logout"
          }),
          iconPosition: "start",
          label: "Logout",
          "data-cy": "logout-tab-button"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PanelContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TabPanel, {
        value: tabIndex,
        index: 0,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TitleTypography, {
          children: "Applications & Tickets"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BookingInterestManagement_BookingInterestManagement, {
          bookingInterests: bookingInterests,
          fetchBookingInterests: fetchBookingInterests
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TabPanel, {
        value: tabIndex,
        index: 1,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TitleTypography, {
          children: "Account Details"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubTitleTypography, {
          children: "Manage your personal and account details"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MainInfo_MainInfo, {
          handleSubmit: handleMainInfo,
          profile: profile,
          fetchProfile: fetchProfile
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
      open: snackbarErrorOpen,
      autoHideDuration: 10000,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
        onClose: handleClose,
        severity: "error",
        sx: {
          width: "100%",
          fontSize: "16px"
        },
        children: "Save failed!"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
      open: snackbarSuccessOpen,
      autoHideDuration: 6000,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
        onClose: handleClose,
        severity: "success",
        sx: {
          width: "100%",
          fontSize: "16px",
          marginTop: "70px"
        },
        children: "Successfully Saved!"
      })
    })]
  });
};

/* harmony default export */ var Profile_Profile = ((0,router.withRouter)(Profile));
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./src/components/Auth/WithAuthHandler/WithAuthHandler.tsx
var WithAuthHandler = __webpack_require__(8885);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 1 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(11463);
// EXTERNAL MODULE: ./src/contexts/CustomThemeProvider.tsx + 2 modules
var CustomThemeProvider = __webpack_require__(75044);
;// CONCATENATED MODULE: ./pages/profile.tsx














var ProfilePage = function ProfilePage() {
  var seoTitle = "Profile | That's The Ticket";

  var _useColorModeContext = (0,CustomThemeProvider/* useColorModeContext */.XE)(),
      setColorMode = _useColorModeContext.setColorMode;

  setColorMode("dark");
  var darkTheme = (0,createTheme/* default */.Z)({
    palette: {
      mode: 'dark'
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "".concat(seoTitle)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: seoTitle
      }, "ogTitle"), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: seoTitle
      }, "twitterTitle")]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* NavigationBar */.vx, {
      showMenu: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(emotion_element_c39617d8_browser_esm.a, {
      theme: darkTheme,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Profile_Profile, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var profile = ((0,WithAuthHandler/* default */.Z)((0,router.withRouter)(ProfilePage)));

/***/ }),

/***/ 8885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22877);
/* harmony import */ var src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82030);
/* harmony import */ var src_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67455);
/* harmony import */ var src_pages_Allocations_V2_Tables_AllocationTableBody_AllocationTableBody_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28643);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80822);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var withAuthHandler = function withAuthHandler(WrappedComponent) {
  var redirectUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/login";

  var Wrapper = function Wrapper(props) {
    var _useAuthContext = (0,src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_4__/* .useAuthContext */ .E)(),
        user = _useAuthContext.user;

    var children = props.children;

    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
        loading = _useState[0],
        setLoading = _useState[1];

    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
      var isExpiredOrNull = (0,_utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .isTokenExpiredOrNull */ .ji)();

      if (user) {
        if (isExpiredOrNull) {
          router.replace({
            pathname: redirectUrl,
            query: {
              redirectUrl: router.asPath
            }
          });
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
        router.replace({
          pathname: redirectUrl,
          query: {
            redirectUrl: router.asPath
          }
        });
      }
    }, [user]);

    if (loading) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        sx: {
          height: "100vh"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(src_pages_Allocations_V2_Tables_AllocationTableBody_AllocationTableBody_styles__WEBPACK_IMPORTED_MODULE_6__/* .SpinnerContainer */ .eg, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(src_components__WEBPACK_IMPORTED_MODULE_5__/* .LoadingSpinner */ .TK, {
            color: "inherit"
          }), ";"]
        })
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(WrappedComponent, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }));
  };

  return Wrapper;
};

/* harmony default export */ __webpack_exports__["Z"] = (withAuthHandler);

/***/ }),

/***/ 44414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GoogleMapsAutoComplete; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27812);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68239);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22430);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50135);
/* harmony import */ var _mui_material_Autocomplete__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23776);
/* harmony import */ var _mui_icons_material_LocationOn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69308);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86886);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15861);
/* harmony import */ var autosuggest_highlight_parse__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23370);
/* harmony import */ var autosuggest_highlight_parse__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(autosuggest_highlight_parse__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94054);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(56815);
/* harmony import */ var _TextField_TextField__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14491);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  var script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

var autocompleteService = {
  current: null
};
function GoogleMapsAutoComplete(props) {
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(props.value ? props.value : null),
      _React$useState2 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_1__.useState(''),
      _React$useState4 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState3, 2),
      inputValue = _React$useState4[0],
      setInputValue = _React$useState4[1];

  var _React$useState5 = react__WEBPACK_IMPORTED_MODULE_1__.useState([]),
      _React$useState6 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState5, 2),
      options = _React$useState6[0],
      setOptions = _React$useState6[1];

  var loaded = react__WEBPACK_IMPORTED_MODULE_1__.useRef(false);
  var darkTheme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    palette: {
      mode: 'dark'
    }
  });
  var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(); // added hardcoded api key to attempt to fix dev/test deploys
  // TODO: remove and get new token once network issue resolved

  var googleApiKeyHC = "AIzaSyAApCIYwA9Xuu10bjI-AN-hRAcgeH3Ef_M";

  if ( true && !loaded.current) {
    if (!document.querySelector('#google-maps')) {
      loadScript("https://maps.googleapis.com/maps/api/js?key=".concat(googleApiKeyHC, "&libraries=places"), document.querySelector('head'), 'google-maps');
    }

    loaded.current = true;
  }

  var fetch = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function () {
    return (0,_mui_material_utils__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function (request, callback) {
      autocompleteService.current.getPlacePredictions(request, callback);
    }, 400);
  }, []);
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function () {
    var active = true;

    if (!autocompleteService.current && window.google) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
    }

    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({
      input: inputValue
    }, function (results) {
      if (active) {
        var newOptions = [];

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [].concat((0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(newOptions), (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(results));
        }

        setOptions(newOptions);
      }
    });
    return function () {
      active = false;
    };
  }, [value, inputValue, fetch]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    theme: props.newUIUXStyle ? darkTheme : theme,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      fullWidth: true,
      error: props.error ? true : false,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material_Autocomplete__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        id: props.id,
        getOptionLabel: function getOptionLabel(option) {
          return typeof option === 'string' ? option : option.description;
        },
        filterOptions: function filterOptions(x) {
          return x;
        },
        options: options,
        autoComplete: true,
        includeInputInList: true,
        filterSelectedOptions: true,
        value: value,
        noOptionsText: "No locations",
        onChange: function onChange(event, newValue) {
          setOptions(newValue ? [newValue].concat((0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(options)) : options);
          setValue(newValue);
          if (props.onChange) props.onChange(newValue);
        },
        onInputChange: function onInputChange(event, newInputValue) {
          setInputValue(newInputValue);
        },
        onBlur: function onBlur() {
          if (props.onBlur) props.onBlur();
        },
        renderInput: function renderInput(params) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
            children: props.newUIUXStyle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* .TextField */ .n, _objectSpread(_objectSpread({}, params), {}, {
              size: "md",
              placeholder: "Start typing address",
              fullWidth: true,
              error: props.error ? true : false
            })) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, params), {}, {
              label: "Venue Street Address",
              fullWidth: true,
              error: props.error ? true : false
            }))
          });
        },
        renderOption: function renderOption(props, option) {
          var matches = option.structured_formatting.main_text_matched_substrings || [];
          var parts = autosuggest_highlight_parse__WEBPACK_IMPORTED_MODULE_2___default()(option.structured_formatting.main_text, matches.map(function (match) {
            return [match.offset, match.offset + match.length];
          }));
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("li", _objectSpread(_objectSpread({}, props), {}, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
              container: true,
              alignItems: "center",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                item: true,
                sx: {
                  display: 'flex',
                  width: 44
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_icons_material_LocationOn__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                  sx: {
                    color: 'text.secondary'
                  }
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                item: true,
                sx: {
                  width: 'calc(100% - 44px)',
                  wordWrap: 'break-word'
                },
                children: [parts.map(function (part, index) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    component: "span",
                    sx: {
                      fontWeight: part.highlight ? 'bold' : 'regular'
                    },
                    children: part.text
                  }, index);
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                  variant: "body2",
                  color: "text.secondary",
                  children: option.structured_formatting.secondary_text
                })]
              })]
            })
          }));
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        children: props.helperText
      })]
    })
  });
}

/***/ }),

/***/ 61975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ AccessibilityContainer; },
/* harmony export */   "x": function() { return /* binding */ TagContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);

var AccessibilityContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var TagContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    alignItems: "flex-start",
    alignContent: "flex-start",
    gap: theme.space._200,
    alignSelf: "stretch",
    flexWrap: "wrap"
  };
});

/***/ }),

/***/ 43696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LA": function() { return /* binding */ FieldsContainer; },
/* harmony export */   "d0": function() { return /* binding */ DateTextField; },
/* harmony export */   "nC": function() { return /* binding */ DateOfBirthContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90948);
/* harmony import */ var _NumericTextField_NumericTextField__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81249);


var DateOfBirthContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var FieldsContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.space._400,
    alignSelf: "stretch"
  };
});
var DateTextField = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_NumericTextField_NumericTextField__WEBPACK_IMPORTED_MODULE_0__/* .NumericTextField */ ._)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._200,
    flex: "1 0 0"
  };
});

/***/ }),

/***/ 22039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ CustomPhoneInput; },
/* harmony export */   "v": function() { return /* binding */ PhoneNumberContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90948);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_0__);


var PhoneNumberContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var CustomPhoneInput = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_0___default()))(function (_ref2) {
  var theme = _ref2.theme;
  return {
    "& input": {
      border: "1px solid ".concat(theme.colors["neutral.600"], "!important"),
      height: '2rem',
      width: "100%!important",
      backgroundColor: "".concat(theme.colors["neutral.900"], "!important"),
      color: "".concat(theme.colors["neutral.50"], "!important")
    },
    "& ul": {
      backgroundColor: "".concat(theme.colors["neutral.900"], "!important"),
      color: "".concat(theme.colors["neutral.50"], "!important"),
      "& li:hover": {
        backgroundColor: "".concat(theme.colors["neutral.950"], "!important"),
        color: "".concat(theme.colors["white"], "!important"),
        opacity: "1.5!important"
      },
      "& li.highlight": {
        backgroundColor: "".concat(theme.colors["neutral.950"], "!important"),
        color: "".concat(theme.colors["white"], "!important"),
        opacity: "1.5!important"
      }
    }
  };
});

/***/ }),

/***/ 81771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LA": function() { return /* binding */ FieldsContainer; },
/* harmony export */   "Vr": function() { return /* binding */ PhoneNumberVerificationContainer; },
/* harmony export */   "df": function() { return /* binding */ ResendCode; },
/* harmony export */   "gj": function() { return /* binding */ StyledBlueSpan; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);


var PhoneNumberVerificationContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  };
});
var FieldsContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._400,
    alignSelf: "stretch"
  };
});
var ResendCode = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.colors["neutral.500"],
    textAlign: "center",
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts["default"],
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
  };
});
var StyledBlueSpan = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("span")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.colors["blue.400"],
    cursor: "pointer",
    pointerEvents: "auto"
  };
});

/***/ }),

/***/ 28643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ ErrorTooltipContainer; },
/* harmony export */   "Ti": function() { return /* binding */ TableBodyCell; },
/* harmony export */   "ab": function() { return /* binding */ OverflowControl; },
/* harmony export */   "eg": function() { return /* binding */ SpinnerContainer; },
/* harmony export */   "f2": function() { return /* binding */ RightContainer; },
/* harmony export */   "hZ": function() { return /* binding */ TotalTickets; },
/* harmony export */   "sh": function() { return /* binding */ TableBodyRow; }
/* harmony export */ });
/* unused harmony exports WarningTooltipContainer, Value, EmptyTitle, EmptyMessage */
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);


var RightContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme,
      modalStyling = _ref.modalStyling;
  return {
    backgroundColor: theme.colors["neutral.900"],
    borderBottomRightRadius: '1rem',
    height: '100%',
    position: 'relative',
    color: theme.colors["neutral.300"],
    overflow: 'hidden',
    "&:after": {
      content: '""',
      background: modalStyling ? 'linear-gradient(270deg, rgba(33, 33, 33, 0.9) 0%, rgba(33, 33, 33, 0) 100%)' : 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(9,9,9,1) 130%)',
      width: '10rem',
      position: 'absolute',
      right: '0',
      top: '0',
      height: '100%',
      pointerEvents: 'none',
      "@media (max-width: 600px)": {
        background: modalStyling ? 'linear-gradient(270deg, rgba(33, 33, 33, 0.9) 0%, rgba(33, 33, 33, 0) 100%)' : 'linear-gradient(90deg, rgba(255,255,255,0) 60%, rgba(9,9,9,0.8) 130%)'
      }
    },
    "&:before": {
      content: '""',
      background: modalStyling ? 'linear-gradient(270deg, rgba(33, 33, 33, 0.9) 0%, rgba(33, 33, 33, 0) 100%)' : 'linear-gradient(90deg, rgba(9,9,9,.6) 0%, rgba(255,255,255,0) 100%)',
      position: 'absolute',
      pointerEvents: 'none',
      left: '0',
      top: '0',
      transition: 'opacity ease-in-out .3s',
      height: '100%',
      width: '10rem',
      opacity: '0',
      zIndex: '1',
      "@media (max-width: 600px)": {
        background: modalStyling ? 'linear-gradient(270deg, rgba(33, 33, 33, 0.9) 0%, rgba(33, 33, 33, 0) 100%)' : 'linear-gradient(90deg, rgba(9,9,9,.6) 0%, rgba(255,255,255,0) 30%)'
      }
    },
    "&.shadow": {
      "&:before": {
        content: '""',
        opacity: '1'
      }
    }
  };
});
var SpinnerContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "4rem",
    color: theme.colors["neutral.200"]
  };
});
var OverflowControl = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    position: 'absolute',
    width: '100%',
    transition: 'all .8s cubic-bezier(.33,.4,0,.96)'
  };
});
var ErrorTooltipContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.colors["red.500"],
    fontSize: theme.fontSizes.xs,
    fontFamily: theme.fonts["default"]
  };
});
var WarningTooltipContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref5) {
  var theme = _ref5.theme;
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.colors["yellow.400"],
    fontSize: theme.fontSizes.xs,
    fontFamily: theme.fonts["default"]
  };
});
var TableBodyRow = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref6) {
  var theme = _ref6.theme,
      isHighlighted = _ref6.isHighlighted;
  return {
    display: 'grid',
    gridAutoFlow: 'column',
    height: '60px',
    justifyContent: 'space-evenly',
    paddingLeft: '1rem',
    border: isHighlighted ? "2px solid ".concat(theme.colors["blue.500"]) : 'none',
    borderLeft: "none",
    transition: "border 200ms ease-in-out",
    "&:nth-of-type(odd)": {
      backgroundColor: theme.colors["neutral.950"],
      ".cell": {
        backgroundColor: theme.colors["neutral.950"]
      }
    },
    "@media (max-width: 600px)": {
      height: "70px"
    }
  };
});
var TableBodyCell = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref7) {
  var theme = _ref7.theme;
  return {
    width: '112px',
    display: 'grid',
    padding: '0.4rem 0.5rem 0 0.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    gridTemplateRows: 'auto 16px',
    gridTemplateColumns: "1fr",
    position: 'relative',
    '&:hover [data-slot="input"]': {
      background: theme.colors["neutral.950"]
    },
    '&:hover [data-slot="root"]': {
      border: "1px solid ".concat(theme.colors["neutral.700"]),
      boxShadow: "0 2px 4px ".concat(theme.colors["neutral.950"]),
      opacity: 1
    },
    '[data-slot="incrementButton"], [data-slot="decrementButton"]': {
      display: 'flex',
      opacity: 0,
      transition: 'all 0.3s ease'
    },
    '&:hover [data-slot="incrementButton"], &:hover [data-slot="decrementButton"]': {
      display: 'flex',
      opacity: 1
    }
  };
});
var TotalTickets = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (_ref8) {
  var theme = _ref8.theme;
  return {
    fontSize: theme.fontSizes.lg,
    fontFamily: theme.fonts["default"],
    color: theme.colors["neutral.50"],
    fontWeight: theme.fontWeights.bold,
    textAlign: 'center'
  };
});
var Value = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (_ref9) {
  var theme = _ref9.theme;
  return {
    marginTop: '12px',
    width: '100px',
    color: theme.colors["neutral.50"],
    fontSize: theme.fontSizes.lg,
    fontFamily: theme.fonts["default"],
    textAlign: 'center',
    position: 'relative'
  };
});
var EmptyTitle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (_ref10) {
  var theme = _ref10.theme;
  return {
    color: theme.colors["neutral.50"],
    fontSize: theme.fontSizes["2xl"],
    fontWeight: theme.fontWeights.bold,
    fontFamily: theme.fonts["default"]
  };
});
var EmptyMessage = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (_ref11) {
  var theme = _ref11.theme;
  return {
    color: theme.colors["neutral.500"],
    fontSize: theme.fontSizes.lg,
    fontFamily: theme.fonts["default"],
    margin: '1rem 0',
    maxWidth: '40rem',
    textAlign: 'center'
  };
});

/***/ }),

/***/ 2090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ declineAttendanceByIdOrToken; },
/* harmony export */   "T": function() { return /* binding */ confirmAttendanceByIdOrToken; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22877);



var confirmAttendanceByIdOrToken = /*#__PURE__*/function () {
  var _ref = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tokenOrbookingInterestId, acceptedRelatedBookingInterestIds) {
    var fetchUrl, res, resText, resJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            fetchUrl = "/api/backend/attendance/confirm/".concat(tokenOrbookingInterestId);

            if (!(typeof tokenOrbookingInterestId === 'string')) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .defaultFetch */ .zo)(fetchUrl, {
              method: 'POST',
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(acceptedRelatedBookingInterestIds)
            });

          case 5:
            res = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.next = 10;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchWithAuth */ .ri)(fetchUrl, {
              method: 'POST',
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(acceptedRelatedBookingInterestIds)
            });

          case 10:
            res = _context.sent;

          case 11:
            if (!(res.status >= 400 && res.status < 600)) {
              _context.next = 17;
              break;
            }

            _context.next = 14;
            return res.text();

          case 14:
            resText = _context.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 17:
            _context.next = 19;
            return res.json();

          case 19:
            resJson = _context.sent;
            return _context.abrupt("return", resJson);

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](0);
            message = 'Unable to delete session';

            if (_context.t0 instanceof Error) {
              message = _context.t0.message;
            }

            return _context.abrupt("return", {
              error: message
            });

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 23]]);
  }));

  return function confirmAttendanceByIdOrToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var declineAttendanceByIdOrToken = /*#__PURE__*/function () {
  var _ref2 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(tokenOrbookingInterestId) {
    var fetchUrl, res, resText, resJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            fetchUrl = "/api/backend/attendance/decline/".concat(tokenOrbookingInterestId);

            if (!(typeof tokenOrbookingInterestId === 'string')) {
              _context2.next = 8;
              break;
            }

            _context2.next = 5;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .defaultFetch */ .zo)(fetchUrl, {
              method: 'POST'
            });

          case 5:
            res = _context2.sent;
            _context2.next = 11;
            break;

          case 8:
            _context2.next = 10;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchWithAuth */ .ri)(fetchUrl, {
              method: 'POST'
            });

          case 10:
            res = _context2.sent;

          case 11:
            if (!(res.status >= 400 && res.status < 600)) {
              _context2.next = 17;
              break;
            }

            _context2.next = 14;
            return res.text();

          case 14:
            resText = _context2.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 17:
            _context2.next = 19;
            return res.json();

          case 19:
            resJson = _context2.sent;
            return _context2.abrupt("return", resJson);

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](0);
            message = 'Unable to delete session';

            if (_context2.t0 instanceof Error) {
              message = _context2.t0.message;
            }

            return _context2.abrupt("return", {
              error: message
            });

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 23]]);
  }));

  return function declineAttendanceByIdOrToken(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 2892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ setGeocoderInfo; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50029);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);


var geocoder;
var setGeocoderInfo = /*#__PURE__*/function () {
  var _ref = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(placeType, location) {
    var geocoderResponse, _addr$find, _addr$find2, _addr$find3, _addr$find4, _addr$find5, _addr$find6, _addr$find7, _addr$find8, info, addr, neighborhood, sublocality, locality;

    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!geocoder) {
              geocoder = new google.maps.Geocoder();
            } // const geocoder = { current: null };


            if (!(placeType == null || location == null)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            if (geocoder) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            _context.next = 7;
            return geocoder.geocode({
              placeId: placeType.place_id
            });

          case 7:
            geocoderResponse = _context.sent;

            if (geocoderResponse && geocoderResponse.results && geocoderResponse.results.length > 0) {
              info = geocoderResponse.results[0];
              location.placeId = info.place_id;
              location.latitude = info.geometry.location.lat();
              location.longitude = info.geometry.location.lng();
              location.longLocation = info.formatted_address;
              location.shortLocation = "";
              location.detailsJson = "";
              addr = info.address_components;
              neighborhood = ((_addr$find = addr.find(function (a) {
                return a.types.includes('neighborhood');
              })) === null || _addr$find === void 0 ? void 0 : _addr$find.long_name) || "";
              sublocality = ((_addr$find2 = addr.find(function (a) {
                return a.types.includes('sublocality');
              })) === null || _addr$find2 === void 0 ? void 0 : _addr$find2.long_name) || "";
              locality = ((_addr$find3 = addr.find(function (a) {
                return a.types.includes('locality');
              })) === null || _addr$find3 === void 0 ? void 0 : _addr$find3.long_name) || "";
              location.country = ((_addr$find4 = addr.find(function (a) {
                return a.types.includes('country');
              })) === null || _addr$find4 === void 0 ? void 0 : _addr$find4.long_name) || "";
              location.unitOrApartmentNumber = ((_addr$find5 = addr.find(function (a) {
                return a.types.includes('street_number');
              })) === null || _addr$find5 === void 0 ? void 0 : _addr$find5.long_name) || "";
              location.street = ((_addr$find6 = addr.find(function (a) {
                return a.types.includes('route');
              })) === null || _addr$find6 === void 0 ? void 0 : _addr$find6.long_name) || "";
              location.suburb = neighborhood || sublocality || locality || "";
              location.state = ((_addr$find7 = addr.find(function (a) {
                return a.types.includes('administrative_area_level_1');
              })) === null || _addr$find7 === void 0 ? void 0 : _addr$find7.long_name) || "";
              location.postCode = ((_addr$find8 = addr.find(function (a) {
                return a.types.includes('postal_code');
              })) === null || _addr$find8 === void 0 ? void 0 : _addr$find8.long_name) || "";
            }

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function setGeocoderInfo(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 56896:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile",
      function () {
        return __webpack_require__(51686);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1350,1415,2516,265,9774,2888,179], function() { return __webpack_exec__(56896); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);